import { SACalendarData } from './sa-calendar-data';

export class SACalendarSelectorSettings extends SACalendarData {
  constructor(init?: SACalendarSelectorSettings) {
    super();
    Object.assign(this, init);
  }
}
